import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  useContext,
} from "react";
import { useHistory } from 'react-router-dom';
import { Callback } from "./page";
import { IESConfig, IESOptions } from "./constants/IESConfig";
import {
  IESAuthUtilV2,
  abilityBuilder,
  useNetworkResponse,
  AbilityContext,
  I18nContext,
  ConfirmPopUp,
  ProgressPopUp,
  ProgressPopUpV2,
  ToastMsg,
  ErrorPopUp,
  PageNotConfigured,
  UserNotEntitled,SchoolAccountDeactivated ,DeactivatedAccount
} from "@activehub/common-components-spa-resource";
import { delay, map } from "rxjs/operators";
import { Loader } from "./components/loader/Loader";
import ExploreLessonsLoader from './components/explore-lessons/ExploreLessonsLoader';
import {
  setAuthToken,
  setUserIdHeader,
  getUserAbilities,
  getSPAsInRegion,
  getNotifications,
  getOrgDetailsByUserV2,
  getTierInformation,
  getPearsonAdmin,
  getUserPlatform,
  getAppdrawer,
  getCombinedProxyData,
  getAppStatus,
  getIsbnCode,
  updateLastLogin,
  sessionLoginApi,
  sessionLogoutApi,
  setSessionIdHeader,
  getChatToken
} from "./network/ApiService";
import { useAppcues } from './hooks/useAppcues'
import { isProductionEnvironment } from './utils/environmentUtils';
import { footerLinks, MAT_PLATFORM_NAME, USERSTATUSCONST } from "./constants/Config";
import { INSTRUCTOR, ADMIN, LEARNER } from "./constants/Appcues";
import { useLocation } from 'react-router-dom';
import Maintenance from "./components/Maintenance/Maintenance";
import { DeactivatedUserAlert } from "./components/deactivated-user-alert/DeactivatedUserAlert";
import LiveChatButton from './components/live-chat-button/LiveChatButton';
import { handleLoginLogoutEvents } from './utils/autobahn/autobahnHandler';
export const D2COrgIDs = ["urn:pearson:gps:organization:48fb8943-fec7-4c6c-93bd-4f464f56b1d6"];
export const AppContext = React.createContext(null);

const locale = navigator.language || "en-US";
const HTMLEntities = require('html-entities');

const Entities = ('AllHtmlEntities' in HTMLEntities) ? HTMLEntities.AllHtmlEntities : function () {
  this.encode = HTMLEntities.encode;
  this.decode = HTMLEntities.decode;
  this.decodeEntity = HTMLEntities.decodeEntity;

  return this;
}
const entities = new Entities();

const defaultToastObj = {
  title: "",
  msg: "",
  styleClass: "",
  delay: 0,
  autoHide: false,
  toastImg: "",
  show: false,
};

const defaultErrorPopupState = {
  heading: "",
  info: "",
  btnName: "",
  btnStyle: false,
  cancelBtnName: "",
  image: "",
  subInfo: "",
  renderExtraElement: () => { },
};

const defaultProgressPopupState = {
  done: false,
  waitingMsg: "",
  itemName: "",
  type: "",
  loadingImage: "",
  animationDuration: 4,
  onSuccess: () => { },
  status: null,
};

const defaultProgressPopupV2State = {
  isOpen: false,
  animationDuration: 4,
  loadingBg: "",
  info: "",
  subInfo: "",
  progressDone: false,
  onProgressBarFilled: "",
  progressErrorInfo: "",
  progressInfo: "",
  showProgressBar: "",
  propgresstypeIcon: "",
  isCloseBtn: false,
  showSuccessImage: false,
};

const defaultConfirmPopupState = {
  isModalshow: false,
  title: "",
  dialogMsg: "",
  positiveButtonText: "",
  positiveButtonHandle: () => { },
  negativeButtonText: "",
  negativeButtonHandle: () => { },
  positiveButtonStyleClass: "",
  negativeButtonStyleClass: "",
  subInfo: "",
};


const getErrorComponent = (status) => {
  if (status == 404) {
    return <PageNotConfigured />;
  } else if (status == 403) {
    return <div className="user-not-entitled-wrapper">
      <UserNotEntitled />
    </div>;
  } else {
    return '';
  }
}

const emptyAbilities = abilityBuilder([]);

// Reads the applicationId directly out of the current hash URL so it is available before SpaWrapper's effects run
const getApplicationIdFromUrl = () => {
  const match = (window.location.hash || '').match(/#\/application\/([^/?]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

const App = (props) => {
  const [isTokenExist, setIsTokenExist] = useState(false);
  const [isSessionReady, setIsSessionReady] = useState(false);
  const [toast, setToast] = useState(defaultToastObj);
  const [headerDetails, setHeaderDetails] = useState({}); //useState(null);
  const [footerDetails, setFooterDetails] = useState(footerLinks);
  const [urlApplicationId, setUrlApplicationId] = useState(getApplicationIdFromUrl);
  const [errorPopupState, setErrorPopupState] = useState(
    defaultErrorPopupState
  );
  const [progressPopupV2State, setProgressPopupV2State] = useState(
    defaultProgressPopupV2State
  );
  const [progressPopupState, setProgressPopupState] = useState(
    defaultProgressPopupState
  );
  const [confirmPopupState, setConfirmPopupState] = useState(
    defaultConfirmPopupState
  );
  const [errorPopupVisibility, setErrorPopupVisibility] = useState(false);
  const [iesSession, setIesSession] = useState(null);
  const [userName, setUserName] = useState("");
  const [defaultSpaId, setdefaultSpaID] = useState("");
  const [userAbilities, setUserAbilities] = useState(emptyAbilities);
  const [availableSPAs, setAvailableSPAs] = useState([]);
  const [isOnlyStudentHomeSpa, setIsOnlyStudentHomeSpa] = useState(false);
  const [prmId, setPmrId] = useState(null);
  const [redeemedResponse, setRedeemedResponse] = useState(null);
  const [manageAccessCodeDetails , setManageAccessCodeDetails] = useState(null);
  const [isLoadingAccessCodes, setIsLoadingAccessCodes] = useState(false);
  const [manageCodesError, setManageCodesError] = useState("");
  const [currentIsbn, setCurrentIsbn] = useState("");
  const [currentAccessCodeSubscription, setCurrentAccessCodeSubscription] = useState(null);

  const {
    translate: userTranslate,
    loadUserTranslation,
    dispatch,
    translateHTML,
  } = useContext(I18nContext);
  const [translate, setTranslate] = useState(() => userTranslate);
  const [wrapperLevelErrorPage, setWrapperLevelErrorPage] = useState(null);
  const [spaDetailsList, setSpaDetailsList] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [organization, setOrganization] = useState(null);
  const [navItems, setNavItmes] = useState([]);
  const [selectedSpaId, setSelectedSpaId] = useState("");
  const [userId, setUserId] = useState(null);
  const [region, setRegion] = useState("");
  const [isPearsonAdmin, setPearsonAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [userRole, setUserRole] = useState("")
  const [appdrawerList, setAppdrawerList] = useState([])
  const [platformChecked, setPlatformChecked] = useState(false);
  const [combinedBootstrapData, setCombinedBootstrapData] = useState(null);
  const [selectedpath, setSelectedpath] = useState("");
  const [isInactiveUser, setIsInactiveUser] = useState(true);

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const isRedirected = query.get('switch');
  const isM_mode = query.get('m_mode');

  const [isbn, setIsbn] = useState('');
  const [ppdNumber, setPpdNumber] = useState('');
  const [ppidTitle, setPpidTitle] = useState('');
  const [identityToken, setIdentityToken] = useState(null);

  const { appcuesData } = useAppcues();
  const history = useHistory();
  const lastLoginUpdatedRef = useRef(false);
  const platformCheckedRef = useRef(false);

  const handleLogout = useCallback((event) => {
    event?.stopPropagation();
    event?.preventDefault();
    localStorage.removeItem('isRedirectedToMat');
    handleLoginLogoutEvents("logout");
    window.dataLayer = [];
    sessionStorage.removeItem("asset-manifest-/lesson-plan");
    sessionStorage.removeItem("assignmentList_hasCustomSelection");
    sessionStorage.removeItem("assignmentList_storedAllGroups");
    sessionStorage.removeItem("assignmentList_storedSelectedGroups");
    sessionStorage.removeItem("assignmentList_initLoad");
    sessionStorage.removeItem("assignmentList_storedMyGroups");
    sessionStorage.setItem("assignmentList_hasCustomSelection", "false");
    sessionLogoutApi().subscribe(
      () => iesSession?.logout?.(),
      () => iesSession?.logout?.()
    );
  }, [iesSession]);

  const markPlatformChecked = useCallback(() => {
    platformCheckedRef.current = true;
    setPlatformChecked(true);
  }, []);

  const getLastLoginUpdateKey = useCallback(() => {
    const sessionId = window.piSession?.getContextId?.() || 'unknown-session';
    return `lastLoginUpdated:${userId}:${sessionId}`;
  }, [userId]);

  useEffect(() => {
    if (!window.USERPROFILE?.email && !window.USERPROFILE?.userName) return;
   const payload = {email: window.USERPROFILE?.email || window.USERPROFILE?.userName || ""};
    if(!(isOnlyStudentHomeSpa == true)){
      getChatToken(payload).subscribe(
        (response) => {
          setIdentityToken(response?.identityToken);
        },
        () => {
          console.log("Error in API while fetching chat token");
        }
      );
   } 
  }, [window.USERPROFILE?.email, window.USERPROFILE?.userName]);

  let popups = useMemo(() => {
    return {
      errorPopup: {
        setState: (state) => {
          setErrorPopupState({
            ...defaultErrorPopupState,
            onClosePopup: () => setErrorPopupVisibility(false),
            buttonAction: () => setErrorPopupVisibility(false),
            cancelButtonAction: () => setErrorPopupVisibility(false),
            ...state,
          });
        },
        setVisibility: setErrorPopupVisibility,
      },
    };
  }, []);

  const unAuthorizedErrorMessage = useMemo(() => {
    return {
      isOpen: true,
      heading: translate("Sorry!!"),
      info: translate("You are not entitled for this action."),
      subInfo: translate("Please contact Support/Administrator."),
      btnName: translate("Okay, Got it"),
      btnStyle: true,
      image: `${process.env.PUBLIC_URL}/images/error-sorry.svg`,
      onClosePopup: () => setErrorPopupVisibility(false),
      buttonAction: () => setErrorPopupVisibility(false),
      cancelButtonAction: () => setErrorPopupVisibility(false),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function closeToast() {
    setToast(defaultToastObj);
  }

  function closeConfirmPopup() {
    setConfirmPopupState(defaultConfirmPopupState);
  }

  function closeProgressPopupV2() {
    setProgressPopupV2State(defaultProgressPopupV2State);
  }

  function closeProgressPopup() {
    setProgressPopupState(defaultProgressPopupState);
  }

  const userAbilitiesResponse = useNetworkResponse();
  const headerInfoResponse = useNetworkResponse();
  const notificationResponse = useNetworkResponse();
  const pearsonAdminResponse = useNetworkResponse();

  const setToken = useCallback((tokenValue, sessionUserId, sessionObj) => {
    setAuthToken(tokenValue);
    console.log("login Token set in API service:", tokenValue);
    if (!sessionUserId) {
      setIsTokenExist(true);
      return;
    }
    if(document.cookie.indexOf('sessionId') === -1) {
    sessionLoginApi({ userId: sessionUserId }, tokenValue, sessionUserId).subscribe(
      () => { setIsTokenExist(true); setIsSessionReady(true); },
      (error) => {
        console.error('$$Session login failed:', error);
        sessionObj?.logout?.();
        setIsTokenExist(true);
      }
    );
  }else{
    //setting sessionHeader on reload or if session already exist
    const match = document.cookie.match(/(?:^|;\s*)sessionId=([^;]+)/);
    if (match) setSessionIdHeader(decodeURIComponent(match[1]));
    setIsTokenExist(true); setIsSessionReady(true);
  }
  }, []);

  useEffect(() => {
    setUserIdHeader(userId);
  }, [userId]);

  useEffect(() => {
    if (appcuesData === null || !window.Appcues) return;
    const isAllowed = appcuesData.ALLOWED_ORIGIN.includes(window.location.hostname);
    if (!isAllowed) return;
    if (!isProductionEnvironment()) return;
    window.Appcues.track("Login");
  }, [userId, window.Appcues])

  const PMRIDs = ["urn:pearson:gps:productmodelregion:e0fe76ad-bc5a-4dc1-8c7c-caf636e7e2a3",
    "urn:pearson:gps:productmodelregion:9b92df41-f614-408a-8e49-d8a255a7b52a"];

  const getCombinedSuccessData = useCallback((combinedResponse, key) => {
    if (!combinedResponse || !combinedResponse[key] || !combinedResponse[key].success) {
      return null;
    }
    return combinedResponse[key].data;
  }, []);

  const getCombinedError = useCallback((combinedResponse, key) => {
    if (!combinedResponse || !combinedResponse[key] || combinedResponse[key].success) {
      return null;
    }
    return {
      status: combinedResponse[key]?.error?.status,
      data: combinedResponse[key]?.error?.data,
    };
  }, []);

  const applyUserProfileResponse = useCallback((response) => {
    if (!response) {
      setUserName('-');
      return;
    }
    const givenName = response.firstName;
    const familyName = response.lastName;
    const firstInitial = givenName && givenName.length > 0 && givenName[0].toUpperCase();
    const familyInitial = familyName && familyName.length > 0 && familyName[0].toUpperCase();
    localStorage.setItem("loggedUsername", `${givenName || ''} ${familyName || ''}`);
    localStorage.setItem("loggedUserInitials", `${firstInitial || ''}${familyInitial || ''}`);
    setUserName(`${firstInitial || ''}${familyInitial || ''}`);
    window.USERPROFILE = { ...response };
  }, []);

  const applySPAResponse = useCallback((response) => {
    if (!response || !response.length) {
      setSpaDetailsList([]);
      setAvailableSPAs([]);
      return;
    }
    setAvailableSPAs(response);
    const lessonSpaId = response.filter(data => data.description === 'lesson-plan');
    const assessmentsSpaId = response.filter(data => data.description === 'assessments');
    const insightsSpaId = response.filter(data => data.description === 'insights');
    const studentSpaId = response.filter(data => data.description === 'student-home');
    sessionStorage.setItem("lessonSpaId", encodeURIComponent(lessonSpaId[0]?.spaId || '') || null);
    sessionStorage.setItem("assessmentsSpaId", encodeURIComponent(assessmentsSpaId[0]?.spaId || '') || null);
    sessionStorage.setItem("insightsSpaId", encodeURIComponent(insightsSpaId[0]?.spaId || '') || null);
    sessionStorage.setItem("studentSpaId", encodeURIComponent(studentSpaId[0]?.spaId || '') || null);
  }, [setSpaDetailsList]);

  function fetchOrganizationList(combinedResponse = null) {
    userAbilitiesResponse.dispatch({
      type: "STARTED",
    });

    if (combinedResponse) {
      const response = getCombinedSuccessData(combinedResponse, 'organisationDetails');
      const error = getCombinedError(combinedResponse, 'organisationDetails');

      if (response) {
        localStorage.setItem('orgDetailsByUser', JSON.stringify(response));
        const orgIds = response?.organisationDetails?.data || [];
        const organisationList = response?.organisationDetails?.data || [];
        if (organisationList.length) {
          if (organisationList[0]?.userStatus === USERSTATUSCONST.INACTIVE) {
            setIsInactiveUser(true);
            setWrapperLevelErrorPage(<DeactivatedAccount heading={"Account archived"} description={" Unfortunately, your Pearson ActiveHub account is no longer active. Please contact your school administrator for guidance."} />);
            userAbilitiesResponse.dispatch({ type: "SUCCESS", payload: abilityBuilder(userAbilities) });
            return () => { };
          }
          setIsInactiveUser(false);
          const orgsList = organisationList.reduce((filtered, object) => {
            const pmrs = object.productModelRegions.filter(ele => PMRIDs.includes(ele.id));
            if (pmrs?.length) {
              const pmrIds = pmrs.map(ele => ele.id);
              setPmrId(pmrIds && pmrIds[0]);
              const newOrgObject = { ...object, productModelRegionDetails: pmrs, productModelRegions: pmrIds, id: object.organizationId };
              filtered.push(newOrgObject);
            }
            return filtered;
          }, []);
          setOrganization(orgsList);
          buildAbility(organisationList[0]?.permissions);

          const organisationListnonD2C = orgIds.filter(
            (orgItem) => orgItem.organizationId !== D2COrgIDs[0]
          );

          const permissions = organisationListnonD2C[0]?.permissionGroups || [];
          const superAdmin = permissions.some(
            p => (p === "urn:pearson:gps:permissiongroup:3e2a5945-d335-442f-a064-2fd4ff12b740")
          );
          setIsSuperAdmin(superAdmin);
          userAbilitiesResponse.dispatch({
            type: "SUCCESS",
            payload: abilityBuilder(userAbilities),
          });
        }
      } else {
        userAbilitiesResponse.dispatch({
          type: "ERROR",
          payload: error,
        });
        if (error && error?.data?.detail == "NO_ACTIVE_ORGANIZATION_FOUND" && error?.status == 404) {
          setIsInactiveUser(true);
          setWrapperLevelErrorPage(<SchoolAccountDeactivated />);
          return () => { };
        } else if (error && error?.data?.detail == "No Record Found" && error?.status == 404) {
          setIsInactiveUser(true);
          setWrapperLevelErrorPage(<DeactivatedAccount heading={"Account deleted"} description={"Unfortunately, your Pearson ActiveHub account no longer has an active subscription. Please contact your school administrator for guidance."} />)
          return () => { };
        } else if (error?.status == 404) {
          setIsInactiveUser(true);
          setWrapperLevelErrorPage(<SchoolAccountDeactivated />);
          return () => { };
        } else if (error && error.data && error.data.status >= 500) {
          buildAbility([]);
        } else if (error && error.data && error.data.status === 401) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          buildAbility([]);
        } else if (error && error.data && error.data.status === 403) {
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
      }
      return () => { };
    }

    const subscription = getOrgDetailsByUserV2(userId).subscribe(
      (response) => {
        localStorage.setItem('orgDetailsByUser', JSON.stringify(response));
        const orgIds = response?.organisationDetails?.data || [];
        /* const organisationList = orgIds.filter(
            (orgItem) => orgItem.organizationId !== D2COrgIDs[0]
          ); */
          const organisationList = response?.organisationDetails?.data || []
        if (organisationList.length) {
          if (organisationList[0]?.userStatus === USERSTATUSCONST.INACTIVE) {
            setIsInactiveUser(true);
            setWrapperLevelErrorPage(<DeactivatedAccount heading={"Account archived"} description={" Unfortunately, your Pearson ActiveHub account is no longer active. Please contact your school administrator for guidance."} />);
            userAbilitiesResponse.dispatch({ type: "SUCCESS", payload: abilityBuilder(userAbilities) });
            return;
          }
          setIsInactiveUser(false);
          const orgsList = organisationList.reduce((filtered, object) => {
            const pmrs = object.productModelRegions.filter(ele => PMRIDs.includes(ele.id))
            if (pmrs?.length) {
              const pmrIds = pmrs.map(ele => ele.id);
              setPmrId(pmrIds && pmrIds[0]);
              const newOrgObject = { ...object, productModelRegionDetails: pmrs, productModelRegions: pmrIds, id: object.organizationId };
              filtered.push(newOrgObject);
            }
            return filtered;
          }, []);
          setOrganization(orgsList);
          buildAbility(organisationList[0]?.permissions);
          
          const ROLE_PRIORITY_MAP = [
            { id: "urn:pearson:gps:permissiongroup:3e2a5945-d335-442f-a064-2fd4ff12b740", role: "SUPERADMIN" },
            { id: "urn:pearson:gps:permissiongroup:750be208-b1aa-48ff-9940-22dee4a19d3a", role: "ADMIN" },
            { id: "urn:pearson:gps:permissiongroup:ba76b0ed-0930-41ae-8300-52304901c731", role: "MAT ADMIN" },
            { id: "urn:pearson:gps:permissiongroup:46027937-9028-4645-a37a-db549e53eed9", role: "STAFF" },
            { id: "urn:pearson:gps:permissiongroup:2e13c639-2200-43c9-85d5-1762597d11a2", role: "STAFF-READONLY" }
          ];
          const organisationListnonD2C = orgIds.filter(
            (orgItem) => orgItem.organizationId !== D2COrgIDs[0]
          );
          // Detect Super Admin
          const permissions = organisationListnonD2C[0]?.permissionGroups || [];

          const superAdmin = permissions.some(
            p => (p === "urn:pearson:gps:permissiongroup:3e2a5945-d335-442f-a064-2fd4ff12b740") 
          );
          setIsSuperAdmin(superAdmin);
          userAbilitiesResponse.dispatch({
            type: "SUCCESS",
            payload: abilityBuilder(userAbilities),
          });
        }
      },
      (error) => {
        console.log('Error ', error)
        userAbilitiesResponse.dispatch({
          type: "ERROR",
          payload: error,
        });
        console.log("userability error")
        if (error && error?.data?.detail == "NO_ACTIVE_ORGANIZATION_FOUND" && error?.status == 404){
           setIsInactiveUser(true); 
          setWrapperLevelErrorPage(<SchoolAccountDeactivated />);
            return ;
        }else if ( error && error?.data?.detail == "No Record Found" && error?.status == 404){
           setIsInactiveUser(true);  
            setWrapperLevelErrorPage(<DeactivatedAccount heading={"Account deleted"} description={"Unfortunately, your Pearson ActiveHub account is no longer active and has been deleted. Please contact your school administrator for guidance."}/>)
            return ;
        }else if ( error?.status == 404){
           setIsInactiveUser(true);
           setWrapperLevelErrorPage(<SchoolAccountDeactivated />);
            return ;
        }else if (error && error.data && error.data.status >= 500) {
          buildAbility([]);
        } else if (error && error.data && error.data.status === 401 || ( error && error?.status === 401)) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          buildAbility([]);
        } else if (error && error.data && error.data.status === 403) {
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
      }
    );
    return () => subscription.unsubscribe();
  }

  function fetchTierInformation(combinedResponse = null) {
    if (combinedResponse) {
      const response = getCombinedSuccessData(combinedResponse, 'tierInformation');
      if (response && response.length) localStorage.setItem('tier_info', JSON.stringify(response));
      return () => { };
    }

    const subscription = getTierInformation().subscribe(
      (response) => {
        if (response && response.length) localStorage.setItem('tier_info', JSON.stringify(response))
      },
      (error) => {
        console.log('Error ', error)
      }
    );
    return () => subscription.unsubscribe();
  }

  function fetchPearsonAdmin(pmrId, userId, combinedResponse = null) {
    pearsonAdminResponse.dispatch({
      type: "STARTED",
    });

    if (combinedResponse) {
      const response = getCombinedSuccessData(combinedResponse, 'previewLiveStatus');
      const error = getCombinedError(combinedResponse, 'previewLiveStatus');
      if (response !== null && response !== undefined) {
        setPearsonAdmin(response);
        pearsonAdminResponse.dispatch({
          type: "SUCCESS",
          payload: abilityBuilder(userAbilities),
        });
      } else {
        pearsonAdminResponse.dispatch({
          type: "ERROR",
          payload: error,
        });
      }
      return () => { };
    }

    const subscription = getPearsonAdmin(pmrId, userId).subscribe(
      (response) => {
        setPearsonAdmin(response)
        pearsonAdminResponse.dispatch({
          type: "SUCCESS",
          payload: abilityBuilder(userAbilities),
        });
      },
      (error) => {
        pearsonAdminResponse.dispatch({
          type: "ERROR",
          payload: error,
        });
        console.log('Error ', error)
      }
    );
    return () => subscription.unsubscribe();
  }

  const fetchUserPlatformAccess = (combinedResponse = null) => {
    if (combinedResponse) {
      const response = getCombinedSuccessData(combinedResponse, 'userPlatformAccess');
      if (response) {
        const hasMatAccess = response && response?.length && response?.filter(data => data && data?.name?.toLowerCase() === MAT_PLATFORM_NAME.toLowerCase());
        if (hasMatAccess.length) {
          localStorage.setItem('isRedirectedToMat', true);
          window.location.href = decodeURIComponent(hasMatAccess[0].launchUrl.replace('&num;', '#')) + '#/application/dashboard?switch=true';
        }
      }
      markPlatformChecked();
      return () => { };
    }

    const subscription = getUserPlatform().subscribe(
      (response) => {
        const hasMatAccess = response && response?.length && response?.filter(data => data && data?.name?.toLowerCase() === MAT_PLATFORM_NAME.toLowerCase());
        if (hasMatAccess.length) {
          localStorage.setItem('isRedirectedToMat', true);
          // window.attachEvent("onmessage", { "isRedirectedToMat": true });
          window.location.href = decodeURIComponent(hasMatAccess[0].launchUrl.replace('&num;', '#')) + '#/application/dashboard?switch=true';
        }
        markPlatformChecked();
      },
      (err) => {
        console.log("platform access err: ", err);
        markPlatformChecked()
      }
    );
    return () => subscription.unsubscribe();
  }

  const getUserRole = useCallback(() => {
    let role = ""
    let isInstructor = userAbilities.can("VIEW", "LESSON_PLAN");
    let isStudent = userAbilities.can("VIEW", "STUDENT_HOME");
    setUserRole(prevRole => {
      if (prevRole === "") {
        if (isPearsonAdmin) {
          role = ADMIN;
          return role;
        }
        else {
          if (isStudent && !isInstructor) role = LEARNER;
          if (!isStudent && isInstructor) role = INSTRUCTOR;
          return role;
        }
      }
    })
  }, [userAbilities, isPearsonAdmin]);

    const getAccessCodeDetails = (isbn, pageNumber=0, pageSize=10) => {
      if (currentAccessCodeSubscription) {
          currentAccessCodeSubscription.unsubscribe();
      }
      
      setIsLoadingAccessCodes(true);
      return new Promise((resolve, reject) => {
          const subscription = getIsbnCode(isbn, pageNumber, pageSize).subscribe(
              (response) => {
                  setManageAccessCodeDetails(response);
                  setIsLoadingAccessCodes(false);
                  setCurrentAccessCodeSubscription(null);
                  resolve(response);
              },
              (error) => {
                  console.error("Error fetching access code:", error);
                  setManageAccessCodeDetails(null);
                  setIsLoadingAccessCodes(false);
                  setCurrentAccessCodeSubscription(null);
                  reject(error);
              }
          );
          setCurrentAccessCodeSubscription(subscription);
      });
  }




  useEffect(() => {
    const gtmLoad = window.dataLayer?.length && window.dataLayer?.some(data => data?.event === 'gtm.load');
    getUserRole();
    if (window.USERPROFILE != undefined && organization != null && gtmLoad && userRole) {
      window.dataLayer = window.dataLayer || [];
      let userData = window.USERPROFILE
        const OrgID = organization.filter(
      (orgItem) => orgItem.organizationId !== D2COrgIDs[0]
    );
      let googleLoggedInData = {
        person_id: userData.userId, // User Id
        person_id_type: "IES", // User Authentication Type
        person_role_code: userRole, // User’s Role
        login_session_id: window.piSession?.getContextId(), // Login Session Id
        organization_id:OrgID[0]?.organizationId, // Organization / Institution Id
        organization_id_type: organization[0].name // Organization Type
      }
      /** Fetching Notifications */
      try {
        setNotifications(OrgID[0]?.inApplicationNotificationList || []);
      } catch (e) {
        setNotifications([]);
        console.log("Error in Notification", e);
      }

      {/** Identify data based on ACTHB-6431 */ }
      console.log("userRole for Appcues :", userRole)
      window.Appcues && window.Appcues.identify(
        userData.userId, // unique, required
        {
          createdAt: Date.now(), // Unix timestamp of user signup date
          role: userRole, // Current user’s role or permissions
        }
      );

      window.dataLayer.push(googleLoggedInData);
    }
  }, [availableSPAs, organization, window.dataLayer, userRole]);

  const buildAbility = (ability) => {
    const userAbilities = abilityBuilder(ability);
    setUserAbilities(userAbilities);
    window.GATEWAY = Object.assign(window.GATEWAY || {}, { userAbilities });
  };

  useEffect(() => {
    if (!userId || !isTokenExist || !isSessionReady) return;

    if (isRedirected) {
      localStorage.setItem('isRedirectedToMat', true);
    }

    const shouldCheckPlatform = !platformCheckedRef.current
      && !localStorage.getItem('isRedirectedToMat')
      && !localStorage.getItem('isRedirectedToAH')
      && !isRedirected;

    // if (window.addEventListener) {
    //   window.addEventListener("message", function (e) {
    //     console.log("I am triggered..");
    //     localStorage.setItem('isRedirectedToMat', true);
    //     fetchUserPlatformAccess();
    //   },false);
    // } else {
    //   if (!localStorage.getItem('isRedirectedToMat') && !localStorage.getItem('isRedirectedToAH')) {
    //     fetchUserPlatformAccess();
    //   }
    // }
    headerInfoResponse.dispatch({
      type: "STARTED",
    });
    const subscription = getCombinedProxyData(userId, PMRIDs[0], 'auto').subscribe(
      (combinedResponse) => {
        setCombinedBootstrapData(combinedResponse);

        if (shouldCheckPlatform) {
          fetchUserPlatformAccess(combinedResponse);
        } else {
          markPlatformChecked();
        }

        fetchOrganizationList(combinedResponse);
        fetchTierInformation(combinedResponse);
        fetchAppdrawerList(userId, combinedResponse);
        fetchPearsonAdmin(PMRIDs[0], userId, combinedResponse);
        fetchSpasInRegion(null, combinedResponse);

        const headerResponse = getCombinedSuccessData(combinedResponse, 'hostnameConfiguration');
        const headerError = getCombinedError(combinedResponse, 'hostnameConfiguration');

        if (headerResponse) {
          headerInfoResponse.dispatch({
            type: "SUCCESS",
            payload: headerResponse,
          });
          sessionStorage.setItem("regionDetail", JSON.stringify(headerResponse));
          setRegion(headerResponse.regionId);
        } else {
          headerInfoResponse.dispatch({
            type: "ERROR",
            payload: headerError,
          });
          if (headerError && headerError.data && headerError.data.status >= 500) {
            setHeaderDetails({
              name: "Pearson",
              description: "pearson global gateway",
              headerImageUrl: `${process.env.PUBLIC_URL}/images/Pearson-everest-logo.svg`,
            });
          } else if (headerError && headerError.data && headerError.data.status === 401) {
            handleLogout();
          } else if (headerError && headerError.data && headerError.data.status === 404) {
            setWrapperLevelErrorPage(getErrorComponent(404));
          } else if (headerError && headerError.status === 403) {
            setWrapperLevelErrorPage(getErrorComponent(403));
          }
        }
      },
      (error) => {
        headerInfoResponse.dispatch({
          type: "ERROR",
          payload: error,
        });
        if (error && error.data && error.data.status >= 500) {
          setHeaderDetails({
            name: "Pearson",
            description: "pearson global gateway",
            headerImageUrl: `${process.env.PUBLIC_URL}/images/Pearson-everest-logo.svg`,
          });
        } else if (error && error.data && error.data.status === 401 ||( error && error?.status === 401)) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          console.log("error 404 for region");
          setWrapperLevelErrorPage(getErrorComponent(404));
        } else if (error && error.status === 403) {
          console.log("error 403 for region");
          // if (isRedeemCodePage) return;
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
        console.log("Error in API", error);
        console.log("Error in combined API", error);
      }
    );

    return () => subscription.unsubscribe();
    // platformChecked is read through a ref: as a dependency it re-ran this effect and fired a second getCombinedProxyData call.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isTokenExist, isSessionReady]);

  useEffect(() => {
    const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
    const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
    // Standalone audio/video/image player tabs must not pay the login settle delay.
    const loginSettleDelay = window.location.hash.includes('/digitalLibrary/list/') ? 0 : 3000;
    const iesSubscription = IESAuthUtilV2.load({
      ...IESConfig,
      callbackURL: window.location.href,
      domain: window.location.hostname,
      ...loginParams
    }, IESOptions).pipe(map(iesdata => { window.IES = iesdata; console.log("Login Map", iesdata.getUserId()); return (iesdata) }), delay(loginSettleDelay)).subscribe((session) => {

      setIesSession(session);

      if (!window.IES.getUserId() && isBaseUrl()) {
        console.log("Login Failed", window.IES.getUserId())
        window.location.assign(`${window.location.origin}${window.location.pathname}#/login`);
      } else {
        localStorage.setItem('preLoginUserId', window.IES.getUserId());
        //localStorage.setItem('isRedirectedToAH', true);
        console.log("Login Success", window.IES)
        session.login();
        setUserId(session?.getUserId());
      }


      setUserId(session.getUserId());
      setToken(session.getPiSessionObj().currentToken(), session.getUserId(), session);
      session.onRefresh((refreshEvent) => {
        // setToken(refreshEvent.data);
        refreshEvent.data && setUserId(session.getUserId());
        refreshEvent.data && setToken(refreshEvent.data, session.getUserId(), session);

        if (!refreshEvent.data) {
          console.log("Login Failed")
          sessionStorage.removeItem("asset-manifest-/lesson-plan");
          window.location.assign(`${window.location.origin}${window.location.pathname}#/login`);
        }

      });
    });

    return () => iesSubscription.unsubscribe();
    // no need to call ies again if setters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isBaseUrl = () => {
    // https://qa.pet.ift.pearson-intl.com/activehub/index.html?iesError=login_required&iesErrorDescription=Login+required#/
    // https://stg.pet.ift.pearson-intl.com/activehub/index.html?iesError=login_required&iesErrorDescription=Login+required#/
    console.log('window.location.href', window.location.href);
    let environment = ['dev', 'qa', 'stg', 'perf']
    let gethostname = window.location.hostname.split(".")[0];
    let domainBasedUrl = environment.includes(gethostname) ? `https://${gethostname}.pet.ift.pearson-intl.com/?iesError=login_required&iesErrorDescription=Login+required#/` : 'https://activehub.pearson.com/#/';
    return (window.location.href === domainBasedUrl || window.location.href === "http://gateway.pearson.com:3009/#/");
  }

  useEffect(() => {
    console.log("Process Env", process.env)
    if (!iesSession) return;
    const redirectToPreLogin = () => {
      window.PRELOGIN_URL = '';
      localStorage.clear();
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('lastLoginUpdated:')) {
          sessionStorage.removeItem(key);
        }
      });
      sessionStorage.removeItem("selectedTaskStatuses");
      sessionStorage.removeItem("assignmentList_hasCustomSelection");
      sessionStorage.removeItem("assignmentList_storedAllGroups");
      sessionStorage.removeItem("assignmentList_storedSelectedGroups");
      sessionStorage.removeItem("assignmentList_initLoad");
      sessionStorage.removeItem("assignmentList_storedMyGroups");
      window.location.assign(`${window.location.origin}${window.location.pathname}#/login`);
      if(document?.getElementById("embedded-messaging")) {
        window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession()
            ?.then(() => {
              console.log('Embedded Service session cleared successfully.');
              window.location.reload();
            })
            ?.catch((error) => {
              console.error('Failed to clear the Embedded Service session.', error);
            });   
      }
    }
    iesSession.onLogout(redirectToPreLogin);
  }, [iesSession])

  useEffect(() => {
    if (!iesSession || !iesSession.getUserId() || !combinedBootstrapData) return;
    const appStatus = fetchAppStatus(combinedBootstrapData);
    const profileResponse = getCombinedSuccessData(combinedBootstrapData, 'userDetails');
    const profileError = getCombinedError(combinedBootstrapData, 'userDetails');

    if (profileResponse) {
      applyUserProfileResponse(profileResponse);
    } else {
      if (profileError && profileError.data && profileError.data.status === 401) {
        handleLogout();
      }
      setUserName('-');
      console.log('error in api', profileError)
    }

    return () => appStatus.unsubscribe();
    // dont need to run this effect when setters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iesSession, combinedBootstrapData, applyUserProfileResponse, getCombinedSuccessData, getCombinedError]);

  useEffect(() => {
    if (!iesSession || !isTokenExist || !userId || !organization?.length || lastLoginUpdatedRef.current) {
      return;
    }

    const lastLoginUpdateKey = getLastLoginUpdateKey();

    if (sessionStorage.getItem(lastLoginUpdateKey)) {
      lastLoginUpdatedRef.current = true;
      return;
    }

    const nonD2COrg = organization.find(
      (orgItem) => orgItem.organizationId !== D2COrgIDs[0]
    );
    const orgId = nonD2COrg?.organizationId || organization[0]?.organizationId;

    if (!orgId) return;

    lastLoginUpdatedRef.current = true;
    sessionStorage.setItem(lastLoginUpdateKey, 'true');
    const payload = {
      "lastLoginDate" : new Date().toISOString(),
    };

    const subscription = updateLastLogin(orgId, userId, payload).subscribe(
      () => {},
      (error) => {
        console.log("Error updating last login:", error);
      }
    );

    return () => subscription.unsubscribe();
  }, [getLastLoginUpdateKey, iesSession, isTokenExist, userId, organization]);

  const fetchAppStatus = (combinedResponse = null) => {
    if (combinedResponse) {
      const res = getCombinedSuccessData(combinedResponse, 'appStatus');
      if (res === null || res === undefined) {
        return { unsubscribe: () => { } };
      }
      try {
        if (isM_mode == 'false') {
          sessionStorage.setItem('isM_MODE', isM_mode ? false : true);
        }

        if (res == true && sessionStorage.getItem('isM_MODE') == 'false') {
          let mDiv = document.getElementById('maintenance');
          let rootDiv = document.getElementById('root');

          mDiv.style.display = 'block';
          rootDiv.style.marginTop = '1%';
        }

        if (res == true && !sessionStorage.getItem('isM_MODE')) {
          setWrapperLevelErrorPage(<Maintenance />);
        }
      } catch (err) {
        console.log("Error in fetch App status for m_mode", err)
      }
      return { unsubscribe: () => { } };
    }

    const status = getAppStatus().subscribe(res => {
      console.log("App Status >> ", res)
      try {
        if (isM_mode == 'false') {
          sessionStorage.setItem('isM_MODE', isM_mode ? false : true);
        }

        if (res == true && sessionStorage.getItem('isM_MODE') == 'false') {
          let mDiv = document.getElementById('maintenance');
          let rootDiv = document.getElementById('root');

          mDiv.style.display = 'block';
          rootDiv.style.marginTop = '1%';
        }

        if (res == true && !sessionStorage.getItem('isM_MODE')) {
          setWrapperLevelErrorPage(<Maintenance />);
        }
      } catch (err) {
        console.log("Error in fetch App status for m_mode", err)
      }
      
    },
      err => {
        console.log("Error in status fetch", err)
      })
    return status;
  }


  const fetchSpasInRegion = useCallback((ability, combinedResponse = null) => {
    const resolvedCombinedResponse = combinedResponse || combinedBootstrapData;

    if (resolvedCombinedResponse) {
      const response = getCombinedSuccessData(resolvedCombinedResponse, 'spaInRegion');
      const error = getCombinedError(resolvedCombinedResponse, 'spaInRegion');
      if (response) {
        applySPAResponse(response);
      } else if (error) {
        if (error && error.data && error.data.status >= 500) {
          setSpaDetailsList([])
        } else if (error && error.data && error.data.status === 401) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          setSpaDetailsList([])
          setWrapperLevelErrorPage(getErrorComponent(404));
        } else if (error && error.status === 403) {
          setSpaDetailsList([]);
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
        console.log('Error in API', error)
      }
      return;
    }

    if (!region) return;
    return getSPAsInRegion(region).subscribe(
      response => {
        applySPAResponse(response);
      },
      error => {
        if (error && error.data && error.data.status >= 500) {
          setSpaDetailsList([])
        } else if (error && error.data && error.data.status === 401 || (error && error?.status === 401)) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          setSpaDetailsList([])
          setWrapperLevelErrorPage(getErrorComponent(404));
        } else if (error && error.status === 403) {
          let response = [];
          setSpaDetailsList([]);
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
        console.log('Error in API', error)
      },
    );
  }, [region, setSpaDetailsList, iesSession, setSelectedSpaId, applySPAResponse, getCombinedError, getCombinedSuccessData, combinedBootstrapData])

  const setAllowedSPAsInRegion = useCallback((ability) => {
    if (availableSPAs.length === 0) return;
    const allowedSPA = availableSPAs.filter(spa => {
      const { action, subject } = spa.ability;
      return action ? ability.can(action, subject) : false;
    });

    setSpaDetailsList(allowedSPA)
    const defaultSpaId = allowedSPA.filter(spa => {
      return (spa.spaId === urlApplicationId) ? spa : false
    });

    if (defaultSpaId[0]) {
      setSelectedSpaId(defaultSpaId[0]?.spaId);
    } else {
      /**
       * if logged in user is student then load student spa 
       * or load home page
       */
      if (allowedSPA[0]?.description == "student-home") {
        setSelectedSpaId(allowedSPA[0]?.spaId);
      } else {
        setSelectedSpaId('dashboard');
      }
    }
  }, [availableSPAs, setSpaDetailsList, setSelectedSpaId])

  const fetchAppdrawerList = ((userId, combinedResponse = null) => {
    if (combinedResponse) {
      const response = getCombinedSuccessData(combinedResponse, 'appDrawerList');
      const error = getCombinedError(combinedResponse, 'appDrawerList');
      if (response) {
        setAppdrawerList(response)
      } else if (error && error.data && error.data.status === 401) {
        handleLogout();
      } else if (error && error.data && error.data.status === 403) {
        setWrapperLevelErrorPage(getErrorComponent(403));
      } else {
        setAppdrawerList([]);
      }
      return () => { };
    }

    const subscription = getAppdrawer(userId).subscribe(
      (response) => {
        setAppdrawerList(response)
      },
      (error) => {
        if (error && error.data && error.data.status >= 500) {
          setAppdrawerList([]);
        } else if (error && error.data && error.data.status === 401 || (error && error?.status === 401)) {
          handleLogout();
        } else if (error && error.data && error.data.status === 404) {
          setAppdrawerList([]);
        } else if (error && error.data && error.data.status === 403) {
          setWrapperLevelErrorPage(getErrorComponent(403));
        }
      }
    );
    return () => subscription.unsubscribe();
  })

  const appContextValue = useMemo(() => {
    return {
      headerDetails,
      setHeaderDetails,
      footerDetails,
      setFooterDetails,
      region,
      setRegion,
      locale,
      iesSession,
      handleLogout,
      userName,
      translate,
      translateHTML,
      setTranslate,
      wrapperLevelErrorPage,
      setWrapperLevelErrorPage,
      setUserName,
      defaultSpaId,
      selectedSpaId,
      setSelectedSpaId,
      userId,
      spaDetailsList,
      closeConfirmPopup,
      closeProgressPopupV2,
      closeProgressPopup,
      setProgressPopupState,
      setProgressPopupV2State,
      setConfirmPopupState,
      setToast,
      unAuthorizedErrorMessage,
      fetchSpasInRegion,
      entities,
      notifications,
      setNotifications,
      availableSPAs,
      setAllowedSPAsInRegion,
      setUrlApplicationId,
      isOnlyStudentHomeSpa,
      setIsOnlyStudentHomeSpa,
      navItems,
      setNavItmes,
      organization,
      isPearsonAdmin,
      isSuperAdmin,
      appdrawerList,
      setSelectedpath,
      selectedpath,
      isInactiveUser,
      ...popups,
      isbn,
    setIsbn,
    ppdNumber,
    setPpdNumber,
    ppidTitle,
    setPpidTitle,
    redeemedResponse, 
    setRedeemedResponse,
    prmId, 
    setPmrId,
    availableSPAs,
    manageAccessCodeDetails,
    setManageAccessCodeDetails,
    isLoadingAccessCodes,
    setIsLoadingAccessCodes,
    getAccessCodeDetails,
    setManageCodesError,
    manageCodesError,
    setCurrentIsbn,
    currentIsbn
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    headerDetails,
    footerDetails,
    region,
    iesSession,
    handleLogout,
    userName,
    setUserName,
    defaultSpaId,
    selectedSpaId,
    userId,
    spaDetailsList,
    popups,
    notifications,
    availableSPAs,
    setAllowedSPAsInRegion,
    setUrlApplicationId,
    wrapperLevelErrorPage,
    isOnlyStudentHomeSpa,
    setIsOnlyStudentHomeSpa,
    navItems,
    organization,
    isPearsonAdmin,
    isSuperAdmin,
    appdrawerList,
    setSelectedpath,
    selectedpath,
    isInactiveUser,
    isbn,
    ppdNumber, 
    ppidTitle, 
    setPpidTitle,
    redeemedResponse,
    prmId,
    availableSPAs,
    manageAccessCodeDetails,
    setManageAccessCodeDetails,
    isLoadingAccessCodes,
    setIsLoadingAccessCodes,
    getAccessCodeDetails,
    setManageCodesError,
    manageCodesError,
    setCurrentIsbn,
    currentIsbn,
    currentAccessCodeSubscription
  ]);

  if (!window.piSession || !userId) {
    return <Loader />
  }
  else if (!isTokenExist || !userId || userAbilitiesResponse.isLoading || headerInfoResponse.isLoading || pearsonAdminResponse.isLoading) {
    return <ExploreLessonsLoader />;
  }
  return (
    <AppContext.Provider value={appContextValue}>
      <AbilityContext.Provider value={userAbilities}>
        <Suspense fallback={<h1> error </h1>}>
        {!(isOnlyStudentHomeSpa == true) &&  <>
          {(identityToken != null) && <LiveChatButton isAuthenticated={true} identityToken={identityToken} />}
        </>}
          <ToastMsg
            title={toast.title}
            show={toast.show}
            msg={toast.msg}
            status={toast.status}
            onClose={() => closeToast()}
            styleClass={toast.styleClass}
            delay={toast.delay}
            autoHide={toast.autoHide}
            toastImg={toast.toastImg}
          />
          <ProgressPopUp
            isOpen={progressPopupState.isOpen}
            waitingMsg={progressPopupState.waitingMsg}
            done={progressPopupState.done}
            itemName={progressPopupState.itemName}
            type={progressPopupState.type}
            successMsg={progressPopupState.successMsg}
            animationDuration={progressPopupState.animationDuration}
            onSuccess={progressPopupState.onSuccess}
            status={progressPopupState.status}
            loadingImage={progressPopupState.loadingImage}
            headerContent={progressPopupState.headerContent}
            footerCustomElement={progressPopupState.footerCustomElement}
          />
          <ProgressPopUpV2
            isOpen={progressPopupV2State.isOpen}
            animationDuration={progressPopupV2State.animationDuration}
            loadingBg={progressPopupV2State.loadingBg}
            info={progressPopupV2State.info}
            subInfo={progressPopupV2State.subInfo}
            progressDone={progressPopupV2State.progressDone}
            onProgressBarFilled={progressPopupV2State.onProgressBarFilled}
            progressErrorInfo={progressPopupV2State.progressErrorInfo}
            progressInfo={progressPopupV2State.progressInfo}
            showProgressBar={progressPopupV2State.showProgressBar}
            propgresstypeIcon={progressPopupV2State.propgresstypeIcon}
            customFooter={progressPopupV2State.customFooter}
            footerClass={progressPopupV2State.footerClass}
            isCloseBtn={progressPopupV2State.isCloseBtn}
            closePopup={progressPopupV2State.closePopup}
            showSuccessImage={progressPopupV2State.showSuccessImage}
          />
          <ErrorPopUp
            isOpen={errorPopupVisibility}
            heading={errorPopupState.heading}
            info={errorPopupState.info}
            btnName={errorPopupState.btnName}
            buttonAction={errorPopupState.buttonAction}
            btnStyle={errorPopupState.btnStyle}
            cancelBtnName={errorPopupState.cancelBtnName}
            cancelButtonAction={errorPopupState.cancelButtonAction}
            cancelBtnStyle={errorPopupState.cancelBtnStyle}
            image={errorPopupState.image}
            closePopup={errorPopupState.onClosePopup}
            subInfo={errorPopupState.subInfo}
            infoClassName={errorPopupState.infoClassName}
            subInfoClassName={errorPopupState.subInfoClassName}
            renderExtraElement={errorPopupState.renderExtraElement}
          />
          <ConfirmPopUp
            isModalshow={confirmPopupState.isModalshow}
            title={confirmPopupState.title}
            dialogMsg={confirmPopupState.dialogMsg}
            positiveButtonText={confirmPopupState.positiveButtonText}
            positiveButtonHandle={confirmPopupState.positiveButtonHandle}
            negativeButtonText={confirmPopupState.negativeButtonText}
            negativeButtonHandle={confirmPopupState.negativeButtonHandle}
            positiveButtonStyleClass={
              confirmPopupState.positiveButtonStyleClass
            }
            negativeButtonStyleClass={
              confirmPopupState.negativeButtonStyleClass
            }
            subInfo={confirmPopupState.subInfo}
          />
          <Callback />
        </Suspense>
      </AbilityContext.Provider>
    </AppContext.Provider>
  );
};

export default App;
